import { render } from "./PanelAdminUser.vue?vue&type=template&id=43342650&ts=true"
import script from "./PanelAdminUser.vue?vue&type=script&lang=ts"
export * from "./PanelAdminUser.vue?vue&type=script&lang=ts"

import "./PanelAdminUser.vue?vue&type=style&index=0&id=43342650&lang=scss"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__